import { getLoginUrl } from '@connected/api-client/lib/login';
import { handleSSOCallback, ssoSearchSchema } from '@connected/api-client/lib/sso';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { FALLBACK_REDIRECT } from '@/config/auth';
import { queryClient } from '@/lib/query-client';

export const Route = createFileRoute('/sso/')({
    validateSearch: ssoSearchSchema,
    beforeLoad: async ({ search, location }) => {
        console.log(location.searchStr);
        console.log('SSO: Received search params:', search);
        console.log('SSO: Token present:', !!search.token);
        console.log('SSO: Redirect param:', search.redirect);

        // If no token provided, redirect to portaal login with fallback (not current URL to avoid loop)
        if (!search.token) {
            console.error('SSO: No token provided in URL');

            throw redirect({
                href: getLoginUrl(FALLBACK_REDIRECT),
            });
        }

        let redirectTo: string;

        try {
            redirectTo = await handleSSOCallback({
                searchParams: search,
                queryClient,
                fallbackRedirect: FALLBACK_REDIRECT,
            });

            console.log('SSO: handleSSOCallback returned redirectTo:', redirectTo);
        }
        catch (e) {
            // For any error from handleSSOCallback, redirect to portaal login with fallback
            // Use fallback path (not current URL) to avoid infinite loop
            console.error('SSO authentication failed:', e);

            throw redirect({
                href: getLoginUrl(FALLBACK_REDIRECT),
            });
        }

        throw redirect({
            to: redirectTo,
        });
    },
    component: SSOPage,
});

function SSOPage() {
    return (
        <div className="flex h-full w-full items-center justify-center">
            <p>Setting up authentication...</p>
        </div>
    );
}
